module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "AFZC"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "JANUARY 7: Knowing, Loving, Trusting"
    }
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "pAB7S"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#AB_ch08",
      "id": "AB_cha08"
    }
  }, [_vm._v("JANUARY 7"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "chapter2"
  }, [_vm._v("Knowing, Loving, Trusting")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "ext",
    attrs: {
      "id": "pAcaB"
    }
  }, [_c('em', [_vm._v("Be still, and know that I am God.")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pA64g"
    }
  }, [_vm._v("—Psalm 46:10")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pAJy"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_c('b', [_vm._v("S")])]), _vm._v("ometimes revisiting a familiar truth can help us be thankful throughout the day. In Psalm 46, for instance, God calls us to stillness for a specific reason: to know Him. What are we to know about our God? British theologian and pastor John Gill said this:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "ext1"
  }, [_vm._v("“Know”; own and acknowledge that he is God, a sovereign Being that does whatsoever he pleases; that he is unchangeable in his nature, purposes, promises, and covenant; that he is omnipotent, able to help them and deliver them at the last extremity; that he is omniscient, knows their persons, cases, and troubles, and how and where to hide them till the storm is over; that he is the all wise God, and does all things after the counsel of his own will, and makes all things work together for good to them; and that he is faithful to his word and promise, and will not suffer them to be overpressed and bore down with troubles.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAFz"
    }
  }, [_vm._v("The more we know about God, the more readily we can trust Him and love Him. When we revisit the truth that stillness can help us know our God, we can be thankful for His accessibility in our silence before Him.")]), _vm._v(" "), _c('p', {
    staticClass: "left1",
    attrs: {
      "id": "pAgdv"
    }
  }, [_c('em', [_vm._v("Lord, help me pursue greater knowledge of You so that I may love You better.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8b080a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter08.vue
// module id = 90
// module chunks = 0